import { createFileRoute } from "@tanstack/react-router";
import { QaPage, qaJsonLd } from "@/components/QaPage";
import { breadcrumbJsonLd } from "@/lib/seo-jsonld";
import { LAST_REVIEWED } from "@/lib/official-sources";

const QUESTION = "Räknas finansiärer in i PBI-kretsen?";
const SHORT_ANSWER = "Finansiärer med betydande ekonomiskt inflytande (stora privata lån, riskkapital med medbestämmande) kan räknas in i PBI-kretsen och prövas för lämplighet.";

export const Route = createFileRoute("/fraga/vad-galler-for-finansierare-av-verksamhet")({
  component: () => (
    <QaPage
      breadcrumbs={[
        { label: "Hem", to: "/" },
        { label: "Frågor & svar", to: "/fraga" },
        { label: "Räknas finansiärer in i PBI-kretsen" },
      ]}
      question={QUESTION}
      shortAnswer={SHORT_ANSWER}
      body={"Bankfinansiering på normala villkor räknas inte in. Privata lån, gåvolån från familj eller informella investerare är däremot vanliga grunder för utvidgad prövning."}
      source={{ label: "Folkhälsomyndigheten – Serveringstillstånd (vägledning)", href: "https://www.folkhalsomyndigheten.se/livsvillkor-levnadsvanor/alkohol-narkotika-dopning-tobak-och-spel-andts/tillsynsvagledning-enligt-alkohollagen/serveringstillstand/" }}
      extraSources={[]}
      deepGuide={{ to: "/pbi-krets", label: "PBI och finansiering" }}
      related={[{"to": "/fraga/nar-bedoms-ekonomisk-lamplighet", "label": "Hur bedöms ekonomisk lämplighet?"}, {"to": "/fraga/vad-ar-vandel", "label": "Vad menas med 'god vandel' i alkohollagen?"}, {"to": "/fraga/vilka-rakas-till-pbi-kretsen", "label": "Vilka räknas till PBI-kretsen?"}]}
      lastReviewed={LAST_REVIEWED}
    />
  ),
  head: () => ({
    meta: [
      { title: "Räknas finansiärer in i PBI-kretsen?" },
      { name: "description", content: "Finansiärer med betydande ekonomiskt inflytande (stora privata lån, riskkapital med medbestämmande) kan räknas in i PBI-kretsen och prövas för lämplighet." },
      { property: "og:title", content: QUESTION },
      { property: "og:description", content: SHORT_ANSWER },
      { property: "og:url", content: "https://alkoholprovet.se/fraga/vad-galler-for-finansierare-av-verksamhet" },
    ],
    links: [{ rel: "canonical", href: "https://alkoholprovet.se/fraga/vad-galler-for-finansierare-av-verksamhet" }],
    scripts: [
      qaJsonLd({
        url: "https://alkoholprovet.se/fraga/vad-galler-for-finansierare-av-verksamhet",
        question: QUESTION,
        answer: SHORT_ANSWER,
      }),
      breadcrumbJsonLd([
        { label: "Hem", url: "https://alkoholprovet.se/" },
        { label: "Frågor & svar", url: "https://alkoholprovet.se/fraga" },
        { label: "Räknas finansiärer in i PBI-kretsen", url: "https://alkoholprovet.se/fraga/vad-galler-for-finansierare-av-verksamhet" },
      ]),
    ],
  }),
});
